import _ from 'lodash';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

import { List } from 'antd';

import { TableStore } from 'stores/abstract';
import { PitstopTableCacheStore } from 'stores/CacheStore';

class PitstopList extends Component {
  static propTypes = {
    tableStore: PropTypes.instanceOf(TableStore),
    id: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    fetchData: PropTypes.func.isRequired,
    rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    renderItem: PropTypes.func.isRequired,
    height: PropTypes.number,
    onRowClick: PropTypes.func,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    getTableStore: PropTypes.func,
    rowSelection: PropTypes.object,
    rows: PropTypes.array,
    limit: PropTypes.number,
    noInitialLoad: PropTypes.bool,
    rawData: PropTypes.bool,
    filter: PropTypes.object,
    sort: PropTypes.string,
    pagination: PropTypes.object,
    searchValue: PropTypes.string,
    timeRange: PropTypes.any,
  };

  static defaultProps = {
    noInitialLoad: false,
    rawData: false,
  };

  state = {
    editingRowKey: null,
  };

  constructor() {
    super();
  }

  get dataSource() {
    const { data } = this.props;
    return _.filter(data, Boolean);
  }

  async componentDidMount() {
    await this.load();

    if (
      this.tableStore &&
      this.props.data.length !== this.tableStore.data.length
    ) {
      await this.props.fetchData(
        {
          offset: 0,
          limit: this.tableStore.limit || 10,
          filter: this.tableStore.filter || undefined,
          sort: this.tableStore.sort,
        },
        this.tableStore
      );
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.load();
    }

    if (
      !_.isEqual(this.props.searchValue, prevProps.searchValue) ||
      !_.isEqual(this.props.timeRange, prevProps.timeRange)
    ) {
      this.tableStore.reset();
      this.load();
    }

    if (
      this.tableStore &&
      !this.tableStore.loaded &&
      !this.tableStore.pending
    ) {
      this.load();
    }
  }

  get tableStore() {
    if (this.props.tableStore) return this.props.tableStore;
    if (!PitstopTableCacheStore.data.has(this.props.id)) {
      PitstopTableCacheStore.setCacheData(this.props.id, new TableStore());
    }
    return PitstopTableCacheStore.getData(this.props.id);
  }

  load = async () => {
    if (!this.tableStore.loaded) {
      let filter = { ...this.props.filter };

      let filters = {
        offset: 0,
        limit: this.props.limit || 10,
        sort: this.props.sort,
      };

      if (!_.isEmpty(filter)) {
        filters.filter = filter;
      }

      await this.props.fetchData(filters, this.tableStore);
    }

    if (this.props.getTableStore) {
      this.props.getTableStore(this.tableStore);
    }
  };

  handleListChange = async (page) => {
    const { pagination } = this.props;

    let offset = (page - 1) * pagination.limit;

    this.tableStore.reset();
    await this.props.fetchData(
      {
        offset: offset,
        limit: pagination.limit,
        sort: this.tableStore.sort,
        filter: this.tableStore.filter,
      },
      this.tableStore
    );
  };

  render() {
    const { renderItem, pagination } = this.props;

    //empty fallback
    const {
      count = 0,
      offset = 0,
      limit = this.props.limit,
      loaded = false,
    } = this.tableStore || {};

    const props = {
      dataSource: this.dataSource,
      loading: !loaded,
      renderItem,
      pagination: {
        pageSize: limit || this.props.limit,
        total: count,
        current: offset / (limit || this.props.limit) + 1,
        onChange: this.handleListChange,
        ...pagination,
      },
    };

    return (
      <>
        <List {...props} />
      </>
    );
  }
}

export default observer(PitstopList);
